<div class="container-fluid h-100 p-5">
    <div class="m-auto login-panel p-4 col-12 col-xl-4 col-md-6">

        <div class="row">
            <mat-form-field class="col">
                <input matInput placeholder="Email" [(ngModel)]="email" [formControl]="ValidEmail" required>
                <mat-error *ngIf="!ValidEmail.valid">
                    Email incorrect
                </mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col">
                <input matInput placeholder="Nouveau mot de passe" [(ngModel)]="pwd1" [formControl]="IsPassword1Valid"
                       required [type]="IsPasswordVisible ? 'text' : 'password'" (keyup)="onPWD1KeyUpEvent()">
                <mat-icon class="material-symbols-outlined" matSuffix (click)="$event.stopPropagation(); IsPasswordVisible = !IsPasswordVisible">
                    {{IsPasswordVisible ? 'visibility_off' : 'visibility'}}
                </mat-icon>
                <mat-error *ngIf="!IsPassword1Valid.valid">
                    Au moins 12 caractères avec une majuscule, un caractère spécial et un chiffre
                </mat-error>
            </mat-form-field>
        </div>
        <div class="row">
            <mat-form-field class="col">
                <input matInput placeholder="Confirmer mot de passe" [(ngModel)]="pwd2" [formControl]="IsPassword2Valid"
                       required [type]="IsConfirmationPasswordVisible ? 'text' : 'password'" (keyup)="onPWD2KeyUpEvent()">
                <mat-icon class="material-symbols-outlined" matSuffix (click)="$event.stopPropagation(); IsConfirmationPasswordVisible = !IsConfirmationPasswordVisible">
                    {{IsConfirmationPasswordVisible ? 'visibility_off' : 'visibility'}}
                </mat-icon>
                <mat-error *ngIf="!IsPassword2Valid.valid">
                    Au moins 12 caractères avec une majuscule, un caractère spécial et un chiffre
                </mat-error>
            </mat-form-field>
        </div>
        <div class="row mt-3">
            <button class="col mx-2" mat-raised-button color="primary" (click)="resetPassword()" [disabled]="!CanAskNewPassword()">
                Envoyer
            </button>
        </div>
    </div>
</div>